import {BaseCardData, CardClickPopupType} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum} from '@colonist/game-states'

export function getCommodityCardData(): BaseCardData[] {
    return [
        {
            cardEnum: CardEnum.CommodityBack,
            cardTypeEnum: CardTypeEnum.Commodity,
            isCardBack: true,
            clickPopupType: CardClickPopupType.None,
            allowableTurnStates: undefined,
        }, {
            cardEnum: CardEnum.Cloth,
            cardTypeEnum: CardTypeEnum.Commodity,
            isCardBack: false,
            clickPopupType: CardClickPopupType.TradeWindow,
            allowableTurnStates: undefined,
        }, {
            cardEnum: CardEnum.Coin,
            cardTypeEnum: CardTypeEnum.Commodity,
            isCardBack: false,
            clickPopupType: CardClickPopupType.TradeWindow,
            allowableTurnStates: undefined,
        }, {
            cardEnum: CardEnum.Paper,
            cardTypeEnum: CardTypeEnum.Commodity,
            isCardBack: false,
            clickPopupType: CardClickPopupType.TradeWindow,
            allowableTurnStates: undefined,
        },
    ]
}
